import React from "react";
import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Radio from "@material-ui/core/Radio";
import clsx from "clsx";
import { CloseRounded } from "@material-ui/icons";

// export function getFontSize() {
// 	// const queries = {
// 	// 	xs: '(min-width: 320px)', //query for xs devices
// 	// 	sm: '(min-width: 720px)',
// 	// 	md: '(min-width: 1024px)',
// 	// 	lg: '(min-width: 1366px)',
// 	// 	xlg: '(min-width: 1920px)',
// 	// };

// 	// if (window.innerWidth > 1920) {
// 	// 	return {
// 	// 		small: '20px',
// 	// 		medium: '28px',
// 	// 		large: '36px',
// 	// 	};
// 	// } else if (window.innerWidth > 1440) {
// 	// 	return {
// 	// 		small: '16px',
// 	// 		medium: '20px',
// 	// 		large: '24px',
// 	// 	};
// 	// }
// 	// else if(useMediaQuery(queries.md))
// 	// {
// 	//   return {
// 	//     small: '12px',
// 	//     medium: '16px',
// 	//     large: '20px'
// 	//   }
// 	// }
// }

export const Title = styled.div`
  font-size: 25px;
  font-family: "Prompt", sans-serif;
  margin: 0.5rem;
  align-self: center;
  font-weight: 500;
`;

export const SubTitle = styled.div`
  font-size: 20px;
  font-family: "Prompt", sans-serif;
  margin: 0rem 0rem 1rem 0rem;
  font-weight: 500;
`;

export const SmallTitle = styled.div`
  font-size: 16px;
  font-family: "Prompt", sans-serif;
  align-self: center;
  font-weight: 500;
`;

export const FlexRow = styled.div`
  display: flex;
  flex-direction: ${(props)=>(props.reverse?"row-reverse":"row")};
  @media only screen and (max-width: ${(props)=>(props.responsive?props.responsive:null)}){
    flex-direction: column;
    padding: 0 8px;
  }
`;

export const Value = styled.div`
  margin: 5px;
  color: #ff6f00;
  font-family: "Prompt", sans-serif;
  font-size: 20px;
  font-weight: 500;
`;

export const Text = styled.div`
  color: rgba(0, 0, 0, 0.8);
  font-family: "Prompt", sans-serif;
  font-size: 16px;
  align-self: center;
  font-weight: 400;
`;

export const Price = styled.div`
  align-self: center;
  font-size: 20px;
  font-family: "Prompt", sans-serif;
  color: #ff6f00;
`;

export const RootContainer = styled.div`
  margin: 1rem 0rem 1rem 0rem;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
`;

export const TitleContainer = styled.div`
  width: 95%;
  align-self: center;
  display: flex;
  flex-direction: row;
`;

export const SummaryCardContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-self: center;
  width: 95%;
  height: 100%;
  flex-wrap: wrap;
`;

export const SummaryCardOuter = styled.div`
  display: flex;
  flex-direction: column;
  height: ${(props) => props.height?props.height:"100%"};
  width: ${(props) => props.width?props.width:"100%"};
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1);
  
`;

export const SummaryCardInner = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem 2rem 1rem 2rem;
  height: 100%;
`;

export const DownArrow = styled.i`
  align-self: flex-end;
  font-size: 24px;
  margin: 0 0 0 0.5rem;
  align-self: center;
  cursor: pointer;
`;

export const Ellipse = styled.div`
  height: 10px;
  width: 10px;
  background-color: rgba(99, 99, 99, 0.5);
  border-radius: 5px;
  margin: 1px;
`;

export const CloseButton = styled(CloseRounded)`
  background: #00ad6f;
  border-radius: 20px;
  width: 40px !important;
  height: 40px !important;
  align-self: flex-end;
  position: sticky;
  position: -webkit-sticky;
  top: 2rem;
  right: 2rem;
  cursor: pointer;
  z-index: 1000;
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PopoverRoot = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 10px;
  font-family: "Prompt", sans-serif !important;
  margin-top: 5px;
  margin-left: 20px;
  min-width: 320px;
  min-height: 100px;
`;
export const PopoverDoneButton = styled.div`
  bottom: 0;
  width: 100%;
  align-self: center;
  display: flex;
  flex-direction: column;
  height: 45px;
  background: #ff6f00;
  border-radius: 0 0 10px 10px;
  text-align: center;
  font-family: "Prompt", sans-serif !important;
  font-size: 20px;
  color: white;
  justify-content: space-around;
  cursor: pointer;
`;

const useStyles = makeStyles({
  root: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  icon: {
    borderRadius: "50%",
    width: 24,
    height: 24,
    boxShadow:
      "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: "#f5f8fa",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    "$root.Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: "#ebf1f5",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background: "rgba(206,217,224,.5)",
    },
  },
  checkedIcon: {
    backgroundColor: "#fff",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 24,
      height: 24,
      backgroundImage: "radial-gradient(#00AD6F,#00AD6F 25%,transparent 50%)",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#fff",
    },
  },
});

export function RadioButton(props) {
  const classes = useStyles();

  return (
    <Radio
      className={classes.root}
      disableRipple
      color="primary"
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      {...props}
    />
  );
}

export const FormTextArea = styled.textarea`
  width: 100%;
  align-self: left;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif !important;
  font-size: 14px !important;
  padding: 1rem;
  background: none;
  border: none;
  outline: none;
`;

export const DateRangeField = styled.input`
  border: none !important;
  font-size: 16px !important;
  max-width: 70px;
  font-family: "Prompt", sans-serif !important;
  outline: none;
  align-self: center;
  cursor: pointer;
  text-align: center;
  color: black;
  &:focus {
    outline: none;
  }
`;

export const DateFieldContainer = styled.div`
  width: 200px;
  height: 30px;
  margin: 0 1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  border-radius: 20px;
  align-self: center;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);
`;

export const SmallSpinner = styled(() => <CircularProgress size={15} />)`
  /* width: 20px !important; */
  align-self: center;
`;

export const InputContainer = styled.div`
  width: 100%;
  border-radius: 20px;
  background-color: #ececec;
  margin: 10px 0 10px 0;
  min-height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`;

export const InputText = styled.input`
  width: 95%;
  align-self: center;
  background: none;
  border: none;
  font-size: 16px !important;
  outline: none;
  padding-left: 10px;
`;

export const InputSelect = styled.select`
  width: 95%;
  align-self: center;
  background: none;
  border: none;
  font-size: 16px !important;
  outline: none;
`;

export const Button = styled.div`
  font-size: 20px;
  color: ${(props) => (props.color === "secondary" ? "#ff6f00" : "#00AD6F")};
  cursor: pointer;
`;
